import activesPhoto from '../static/images/advice_photos/actives.jpg';
import familyPhoto from '../static/images/advice_photos/family.jpg';
import alpineLakesPhoto from '../static/images/advice_photos/monthly_lakes.jpg';
import dogFriendlyPhoto from '../static/images/advice_photos/dog_friendly.jpg';
import CategoryCardContainer from './CategoryCardContainer';
import CategoryCard from './CategoryCard';
import { useTranslation } from 'react-i18next';

const AdviceCategorySection = () => {
    const {t} = useTranslation();
    const transalatedTitles = [
        `${t('Homepage.AdviceCategorySection.alpineLakes')}`,
        `${t('Homepage.AdviceCategorySection.family')}`,
        `${t('Homepage.AdviceCategorySection.hard')}`,
        `${t('Homepage.AdviceCategorySection.dogFriendly')}` //
    ]
    return (
        <CategoryCardContainer>
            <CategoryCard photo={alpineLakesPhoto} title={transalatedTitles[0]} filterString="alpine-lakes" />
            <CategoryCard photo={familyPhoto} title={transalatedTitles[1]} filterString="family" />
            <CategoryCard photo={activesPhoto} title={transalatedTitles[2]} filterString="hard" />
            <CategoryCard photo={dogFriendlyPhoto} title={transalatedTitles[3]} filterString="dog-friendly" />
        </CategoryCardContainer>
    )
}

export default AdviceCategorySection;
